import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { normalizeRole } from "../config/permissions";

/**
 * Renders `children` only when `user.role` is one of `allowedRoles`.
 * Otherwise redirects to `/unauthorized` (or `fallbackPath` if set).
 */
export default function RoleRoute({ allowedRoles, fallbackPath, children }) {
  const { user, loading, token } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!user?.role) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(user?.role);
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to={fallbackPath || "/unauthorized"} replace state={{ from: location }} />;
  }

  return children;
}
